import { useState, useCallback, useEffect } from 'react';

const SpeechRecognition =
  typeof window !== 'undefined' &&
  (window.SpeechRecognition || window.webkitSpeechRecognition);

export function useDictation(options = {}) {
  const { onResult, onError, lang = 'es-ES' } = options;
  const [isListening, setIsListening] = useState(false);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    setSupported(!!SpeechRecognition);
  }, []);

  const start = useCallback(() => {
    if (!SpeechRecognition || !supported) {
      onError?.(new Error('El dictado por voz no está soportado en este navegador.'));
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = lang;
    recognition.onresult = (event) => {
      const transcript = event.results?.[0]?.[0]?.transcript ?? '';
      if (transcript) onResult?.(transcript);
    };
    recognition.onerror = (event) => {
      if (event.error !== 'aborted') onError?.(new Error(event.error));
      setIsListening(false);
    };
    recognition.onend = () => setIsListening(false);
    recognition.start();
    setIsListening(true);
  }, [supported, lang, onResult, onError]);

  const stop = useCallback(() => {
    setIsListening(false);
  }, []);

  return { isListening, start, stop, supported };
}
